import LeadsManagementCard from './LeadsManagementCard'
import LeadsNotFollowedUpCard from './LeadsNotFollowedUpCard'

export default function DashboardBottomSection({
  leadsManagement,
  leadsNotFollowedUp = [],
  period,
  customRange,
}) {
  return (
    <section className="grid items-stretch gap-4 xl:grid-cols-[minmax(280px,340px)_1fr]">
      <LeadsManagementCard
        data={leadsManagement}
        period={period}
        customRange={customRange}
      />
      <LeadsNotFollowedUpCard data={leadsNotFollowedUp} />
    </section>
  )
}
